var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.742C2.8275 4.187 4.731 3.5885 6.582 3.4025C8.577 3.2015 10.269 3.497 11.25 4.5305V19.1495C9.8475 18.3545 8.07 18.245 6.4305 18.41C4.6605 18.59 2.8755 19.1015 1.5 19.6265V4.742ZM12.75 4.5305C13.731 3.497 15.423 3.2015 17.418 3.4025C19.269 3.5885 21.1725 4.187 22.5 4.742V19.6265C21.123 19.1015 19.3395 18.5885 17.5695 18.4115C15.9285 18.245 14.1525 18.353 12.75 19.1495V4.5305ZM12 3.1745C10.5225 1.904 8.3805 1.715 6.4305 1.91C4.1595 2.1395 1.8675 2.918 0.4395 3.5675C0.308474 3.6271 0.197363 3.72313 0.119432 3.84415C0.0415 3.96517 3.98571e-05 4.10606 0 4.25L0 20.75C3.4743e-05 20.8755 0.0315557 20.999 0.0916756 21.1091C0.151796 21.2193 0.238593 21.3126 0.344116 21.3805C0.44964 21.4484 0.570517 21.4887 0.695675 21.4978C0.820833 21.5069 0.946271 21.4845 1.0605 21.4325C2.3835 20.8325 4.515 20.111 6.5805 19.9025C8.694 19.6895 10.4655 20.033 11.415 21.218C11.4853 21.3056 11.5743 21.3763 11.6756 21.4249C11.7768 21.4735 11.8877 21.4987 12 21.4987C12.1123 21.4987 12.2232 21.4735 12.3244 21.4249C12.4257 21.3763 12.5147 21.3056 12.585 21.218C13.5345 20.033 15.306 19.6895 17.418 19.9025C19.485 20.111 21.618 20.8325 22.9395 21.4325C23.0537 21.4845 23.1792 21.5069 23.3043 21.4978C23.4295 21.4887 23.5504 21.4484 23.6559 21.3805C23.7614 21.3126 23.8482 21.2193 23.9083 21.1091C23.9684 20.999 24 20.8755 24 20.75V4.25C24 4.10606 23.9585 3.96517 23.8806 3.84415C23.8026 3.72313 23.6915 3.6271 23.5605 3.5675C22.1325 2.918 19.8405 2.1395 17.5695 1.91C15.6195 1.7135 13.4775 1.904 12 3.1745Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/Resources.f72c6538c7a8869cdd17d7e8468e63fb.svg";
export { ForwardRef as ReactComponent };